<app-add-form
  data-testid="purchase-order-add-form"
  #addForm
  [title]="'purchase_order.add.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  [initialData]="currentFormData"
  [getFieldError]="getDetailFieldError.bind(this)"
  (formAction)="onFormAction($event.action)"
  (formValueChanges)="onFormValueChanges($event)"
  (tableAction)="onTableAction({ action: $event.action, data: $event.data, section: $event.section })"
>
  <!-- Row actions for table inside add-form: Delete only-->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <span
        [attr.data-testid]="'purchase-order-add-action-delete-detail-' + rowData.id"
        (click)="onTableAction({ action: 'deleteDetail', data: rowData })"
        class="action-link action-delete cursor-pointer"
      >
        {{ "common.actions.delete" | translate }}
      </span>
    </div>
  </ng-template>
</app-add-form>

<!-- SKU Selection Dialog for Normal Mode -->
<app-purchase-request-item-dialog
  data-testid="purchase-order-add-item-dialog"
  [(visible)]="showSkuDialog"
  [initialData]="editingSkuItem()"
  [editMode]="!!editingSkuItem()"
  [existingItems]="[]"
  [vendorCode]="currentFormData?.vendorCode"
  [vendorSkus]="vendorSKUList()"
  (confirm)="onSkuDialogConfirm($event)"
  (visibleChange)="showSkuDialog.set($event)"
></app-purchase-request-item-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-order-add-toast"></p-toast>
